/**
 * Author: Andrey Morozov
 * Confidential. Proprietary code. Do not distribute without authorization.
 *
 * main.tsx — main (services/operator-web-app).
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { initWebVitals } from './observability/webVitals';
import { initTheme } from '@/config/theme';
import { I18nProvider } from '@/i18n';
import './index.css';

initTheme();

// Suppress Chrome extension noise: "Could not establish connection. Receiving end does not exist."
// This comes from extensions (e.g. React DevTools) messaging a context that was invalidated.
window.addEventListener('unhandledrejection', (event) => {
  const msg = event.reason?.message ?? String(event.reason);
  if (typeof msg === 'string' && msg.includes('Receiving end does not exist')) {
    event.preventDefault();
    event.stopPropagation();
  }
});

// StrictMode disabled in production to avoid double-invoking effects that can trigger React #185 (max update depth)
const root = createRoot(document.getElementById('root')!);
root.render(
  import.meta.env.DEV ? (
    <StrictMode>
      <I18nProvider>
        <App />
      </I18nProvider>
    </StrictMode>
  ) : (
    <I18nProvider>
      <App />
    </I18nProvider>
  )
);

initWebVitals();
